import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Section } from '../models/section';
import { Observable } from 'rxjs';
import { Report } from '../models/report';
import { map } from 'rxjs/operators';
import { Firestore, collection, collectionData, doc, docData, query, orderBy } from '@angular/fire/firestore'

@Component({
    selector: 'app-section',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.css'],
    standalone: false
})
export class SectionComponent implements OnInit {

  constructor(
  private route: ActivatedRoute,
  private firestore: Firestore
  ) { }


  sectionId: string;
  //sectionDoc: AngularFirestoreDocument<Section>;

  section$ : Observable<Section>;
  section: Section;
  listOfReports$: Observable<Report[]>


  ngOnInit() {

    this.getSection();
  }

  getSection()
  {
    this.route.paramMap.subscribe(p => {
      this.sectionId = p.get('secId');

      //this.sectionDoc = this.db.doc('sections/' + this.sectionId);
       const sectionDocRef = doc(this.firestore, 'sections/' + this.sectionId);
       this.section$ = docData(sectionDocRef) as Observable<Section>;


      this.section$
        .subscribe(res => {
          this.section = res;
          document.getElementById('spanTitle').innerHTML = 'Sección ' + this.section.name;
        });

      // Get the reports subcollection as an observable using the modular API
      // const reportsColRef = collection(this.firestore, `sections/${this.sectionId}/reports`);
      // const reportsQuery = query(reportsColRef, orderBy('order', 'asc'));

      // this.listOfReports$ = this.sectionDoc.collection<Report>('reports', ref => {
      //   return ref.orderBy("order", "asc")
      // })
      // .snapshotChanges()
      // .pipe(
      //   map(actions => {
      //     return actions.map(a => {
      //         const data = a.payload.doc.data() as Report
      //         const id = a.payload.doc.id;
      //         return { id, data }
      //       })
      //   })
      // )

    });
  }

}
